import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { WorklistPage } from "@/features/worklist/WorklistPage";

/** The worklist's view lives in the URL: Back returns to it, and the dashboard links straight to one.
 *  Anything malformed is dropped rather than refused. Periods are "7d" and "30d" (a bare number would
 *  be written to the URL in quotes). */
export const worklistSearch = z.object({
  range: z.enum(["today", "7d", "30d", "all"]).optional().catch(undefined),
  filter: z.enum(["symptoms", "tb"]).optional().catch(undefined),
  status: z.string().max(40).optional().catch(undefined),
  q: z.string().max(100).optional().catch(undefined),
  size: z.union([z.literal(25), z.literal(50), z.literal(100)]).optional().catch(undefined),
});
export type WorklistSearch = z.infer<typeof worklistSearch>;

export const Route = createFileRoute("/_app/worklist")({
  validateSearch: worklistSearch,
  component: WorklistPage,
});
